module.exports = __webpack_public_path__ + "img/HiwaQader-Morkel.e32fb6c2.jpg";